import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Location } from 'history';
import { useTranslation } from 'react-i18next';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import { getVersionUrl } from 'common/cacheOverwrite';


const EventCompletPage: React.FC = () => {
  const location            = useLocation() as Location<LocationState>;
  const navigate            = useNavigate();
  const { cardProductCode } = useParams();
  const { t, i18n }         = useTranslation();

  const screenId    = "APPL16";
  const screenName  = t("APPL16.title02");


  ///////////////
  // useCallback
  const callbackBackkeyEvent = useCallback(() => {
    navigate("/main", { state: { query: location.state.query, swiperIndex: 0, tabIndex: "1" }});
  }, [navigate, location]);


  /////////////
  // useEffect
  useEffect(() => {
    i18n.changeLanguage(location.state.query.languageCode);
    callNativeWeb(screenId, screenName);
    footerShowEventWeb("N");

    console.log("QUERY STATE");
    console.log(location.state);

  }, []); // eslint-disable-line

  useEffect(() => {
    document.addEventListener("backpress", callbackBackkeyEvent);
    return () => document.removeEventListener("backpress", callbackBackkeyEvent);
  }, [callbackBackkeyEvent]);


  //////////
  // return
  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <iframe className="productDetail" src={getVersionUrl(`${process.env.REACT_APP_OUTER_HTML_PATH}/card/completed/${cardProductCode}_completed.html`)} allowFullScreen={true} title={'Completed Apply'}/>
        <div className="btnArea">
          <div className="btnWrapTy01">
            <button type="button" className="btnPrimaryTy01" onClick={() => navigate("/main", { state: { query: location.state.query, swiperIndex: 0, tabIndex: "1" }})}><span>{t("COMMON.button.done")}</span></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCompletPage;